<button class="pos-fixed bottom-4 right-4 z-7 p-a-1 p-l-3 p-r-3 b-radius-max bg-col-1 link-2 back-to-top"
        [attr.aria-label]="'Back to top' | translate"
        (click)="backToTop()">
    <i class="icon-chevron-up col-w"
       [style.font-size.em]="1.25"
       aria-hidden="true"></i>
</button>